import type { IResponseMeta } from '@/api/interfaces'
import { getTranslitedTextInCamelCase } from '../helpers'

export const getErrorTextFromResponseMeta = (meta?: IResponseMeta | null) =>
  getTranslitedTextInCamelCase(meta?.description || meta?.message || '') || meta?.status || ''
